import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'api/Api';
import { API_URL } from 'api/ApiUrl';
import { errorHandler } from 'utils/errorHandler';

export const getAPCMFilteredEvent = createAsyncThunk(
    'getAPCMFilteredEvent',
    async (params, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.post(
                `${API_URL.getAPCMFilteredEvents}`,
                params,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );

            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getAPCMEvent = createAsyncThunk(
    'getAPCMEvent',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;

        try {
            const response = await API.post(API_URL.getAPCMEvents, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                baseIndex: 0,
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getEmail = createAsyncThunk(
    'getEmail',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.post(API_URL.getEmails, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                baseIndex: 0,
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
